import "./internal/vs";
import { Type, type, Text, Dom } from "main.core";
const getTag = function getTag(value) {
  return Object.prototype.toString.call(value);
};
const isNodeList = function isNodeList(value) {
  return Type.isObjectLike(value) && getTag(value) === "[object NodeList]";
};
const isJQueryNode = function isJQueryNode(node) {
  return node instanceof jQuery;
};
const in_array = function in_array(value, array) {
  if (Type.isArray(array)) {
    for (var i = 0, l = array.length; i < l; i++) {
      if (value == array[i]) return true;
    }
  }

  return false;
};
let listFunction = {};
const registerFunction = function (name, fu) {
  if (Type.isFunction(name) && name.name !== "") {
    listFunction[name.name] = name;
  } else if (name && Type.isFunction(fu)) {
    listFunction[name] = fu;
  }
};
const getFunction = function (name) {
  if (!name) return false;
  let f;
  if (name.startsWith("VS.VSCore") || name.startsWith("VSCore")) {
    f = VModel.getValue(
      VSCore,
      name.replace("VS.VSCore.", "").replace("VSCore.", "")
    );
  } else if (name.startsWith("VS.")) {
    f = VModel.getValue(VS, name.replace("VS.", ""));
  } else if (name.startsWith("BX.")) {
    f = VModel.getValue(BX, name.replace("BX.", ""));
  } else {
    f = listFunction[name];
  }
  if (Type.isFunction(f)) {
    return f;
  }
  f = window[name];
  if (Type.isFunction(f)) {
    return f;
  }
  return false;
};
const runFunction = function (name, ...arg) {
  if (!name) return;
  let f = getFunction(name);
  if (Type.isFunction(f)) {
    return f(...arg);
  }
};
const utilURL = {
  getBackParam: () => {
    let t = encodeURIComponent(location.pathname + location.search);
    return "backurl=" + t;
  },

  combineURL: (strUrl, Params) => {
    if (!strUrl) strUrl = "";
    if (Params.startsWith("/")) return Params;
    if (Params.startsWith("#")) return strUrl + Params;
    if (Params.indexOf("?") !== -1) Params = Params.replace("?", "");
    if (strUrl.indexOf("?") === -1) {
      return strUrl + "?" + Params;
    } else {
      return strUrl + "&" + Params;
    }
  },
  isAUrl: (a) => {
    let href = a.getAttribute("href");
    return (
      a &&
      a.hash === "" &&
      !href.startsWith("javascript:") &&
      !href.startsWith("#")
    );
  },
  getUrlQueryString: (key, url) => {
    if (!key) return "";
    if (!url) url = window.location.search;
    key = key.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) {
      return "";
    }
    if (!results[2]) {
      return "";
    }
    return decodeURIComponent(results[2]);
  },
  removeLocationHash: (key) => {
    var newKeys = [];
    if (key) {
      var h = location.hash.replace("#", "");
      var keys = h.split("&");
      keys.forEach(function (i) {
        if (type.isNotEmptyString(i) && i.indexOf(key) === -1) {
          newKeys.push(i);
        }
      });
    }
    let noHashURL = window.location.href.replace(/#.*$/, "");
    window.history.replaceState("", document.title, noHashURL);
    if (newKeys.length) {
      location.hash = newKeys.join("&");
    }
  },
  setHashUrl: (name, value) => {
    if (!name) return;
    if (Type.isArray(name)) {
      for (let i = 0, l = name.length; i < l; i++) {
        let v = name[i];
        utilURL.setHashUrl(v.name, v.value);
      }
      return location.hash.replace("#", "");
    }
    if (Type.isPlainObject(name)) {
      for (let key in name) {
        if (name.hasOwnProperty(key)) {
          utilURL.setHashUrl(key, name[key]);
        }
      }
      return location.hash.replace("#", "");
    }
    if (!value) {
      utilURL.removeLocationHash(name);
      return false;
    }
    var newKeys = [name + "=" + value];
    if (type.isNotEmptyString(location.hash)) {
      var h = location.hash.replace("#", "");
      var keys = h.split("&");
      keys.forEach(function (i) {
        if (type.isNotEmptyString(i) && i.indexOf(name) === -1) {
          newKeys.push(i);
        }
      });
    }
    newKeys = newKeys.join("&");
    location.hash = newKeys;
    return newKeys;
  },
  isHashUrl: (name) => {
    if (name) {
      let d = utilURL.getHashUrl(false, true);
      if (!d) return false;
      return d[name] !== "undefined";
    }
    return false;
  },
  getHashUrl: (name, isObj) => {
    if (location.hash) {
      var newKeys = [],
        newObj = {};
      var keys = window.location.hash.replace("#", "").split("&");
      keys.forEach(function (i) {
        if (type.isNotEmptyString(i)) {
          var d = i.split("=");
          if (d.length === 2) {
            var t = {};
            t.name = d[0];
            t.value = d[1];
            newKeys.push(t);
            newObj[t.name] = t.value;
          }
        }
      });
      if (name) {
        var value;
        newKeys.forEach(function (item) {
          if (item.name === name) value = item.value;
        });
        return value;
      }
      if (isObj) return newObj;
      return newKeys;
    }
    return false;
  },
};
const moveToElement = function (moveEl, toEl) {
  let moveEl_pos = moveEl.getBoundingClientRect();
  let toEl_pos = toEl.getBoundingClientRect();

  let moveElClone = BX.clone(moveEl);

  moveElClone.style.position = "fixed";
  moveElClone.style.left = moveEl_pos["x"] + "px";
  moveElClone.style.top = moveEl_pos["y"] + "px";
  moveElClone.style.border = "none";
  moveElClone.style.zIndex = 32767;
  moveElClone.style.maxWidth = moveEl.clientWidth + "px";
  moveElClone.style.maxHeight = moveEl.clientHeight + "px";
  let start_x = moveEl_pos["x"] + 0.5 * moveEl_pos["width"];
  let start_y = moveEl_pos["y"] + 0.5 * moveEl_pos["height"];
  //debugger;
  let delta_x = toEl_pos["x"] + 0.5 * toEl_pos["width"] - start_x;
  let delta_y = toEl_pos["y"] + 0.5 * toEl_pos["height"] - start_y;

  document.body.appendChild(moveElClone);
  void moveElClone.offsetWidth;
  moveElClone.style.transform = "translateX(" + delta_x + "px)";
  moveElClone.style.transform += "translateY(" + delta_y + "px)";
  moveElClone.style.transform += "scale(0.25)"; // уменьшаем до 25%
  moveElClone.style.transition = "1s"; // всё происходит за 1 секунду

  setTimeout(() => document.body.removeChild(moveElClone), 960);
};

let listControl = {};
class control {
  constructor(node, params) {
    this.name = "control";
    this.node = node;
    this.params = params;
    if (!type.isNotEmptyString(node.id)) node.id = "ctrl_" + Text.getRandom();

    this.id = node.id;
    this.type = "node";
    if (typeof bootstrap === "object") {
      if (Dom.hasClass(node, "modal")) {
        this.b5El = node;
      } else {
        this.b5El = BX.findParent(this.node, { class: "modal" });
        if (this.b5El) {
          this.type = "Modal";
        }
      }
      if (!this.b5El) {
        if (Dom.hasClass(node, "offcanvas")) {
          this.b5El = node;
        } else {
          this.b5El = BX.findParent(this.node, { class: "offcanvas" });
        }
        if (this.b5El) {
          this.type = "Offcanvas";
        }
      }
      if (this.b5El) {
        if (this.params.events) {
          let type = this.type.toLocaleLowerCase();
          if (Type.isFunction(this.params.events.hidden)) {
            this.b5El.addEventListener(
              `hidden.bs.${type}`,
              params.events.hidden
            );
          }
          if (Type.isFunction(params.events.show)) {
            this.b5El.addEventListener(`show.bs.${type}`, params.events.show);
          }
          if (Type.isFunction(params.events.hide)) {
            this.b5El.addEventListener(`hide.bs.${type}`, params.events.hide);
          }
          if (Type.isFunction(params.events.shown)) {
            this.b5El.addEventListener(`shown.bs.${type}`, params.events.shown);
          }
        }
        if (bootstrap[this.type]) {
          this.b5Control = bootstrap[this.type].getOrCreateInstance(this.b5El);
        }
      }
    }
  }
  show() {
    if (this.b5Control) {
      this.b5Control.show();
    } else {
      if (Type.isFunction(this.params.events.show)) {
        this.params.events.show(this);
      }
      Dom.show(this.node);
      if (Type.isFunction(this.params.events.shown)) {
        this.params.events.shown(this);
      }
    }
  }
  hide() {
    if (this.b5Control) {
      this.b5Control.hide();
    } else {
      if (Type.isFunction(this.params.events.hide)) {
        this.params.events.hide(this);
      }
      Dom.hide(this.node);
      if (Type.isFunction(this.params.events.hidden)) {
        this.params.events.hidden(this);
      }
    }
  }
}
const CONTROL = {
  add(node, params) {
    if (!node) return false;
    let c = new control(node, params);
    listControl[c.id] = c;
    return c;
  },
  get(id) {
    return listControl[id];
  },
  getList() {
    return listControl;
  },
  setDefaultNode(node) {
    if (!node) return false;
    if (!type.isNotEmptyString(node.id)) node.id = "ctrl_" + Text.getRandom();
    return true;
  },
  registerControl(control) {
    if (control) {
      if (!type.isNotEmptyString(control.id))
        control.id = "ctrl_" + Text.getRandom();
      listControl[control.id] = control;
      return true;
    }
    return false;
  },
};
const convert = {
  ToString: (v, def) => {
    if (type.isNotEmptyString(v)) {
      return String(v);
    } else if (def) {
      return String(def);
    }
    return "";
  },
  ToBool: (value) => {
    if (typeof value === "boolean") return value;
    if (value === "on" || value === "true") {
      return true;
    } else if (value === "off" || value === "false") {
      return false;
    }
    return null;
  },
  StringToDate: (str_date) => {
    str_date = convert
      .ToString(str_date)
      .replace(/(\d+).(\d+).(\d+)/, "$2/$1/$3");
    let d = new Date(str_date);
    return d;
  },
  ToDate: (date, format) => {
    let str_date = convert
      .ToString(date)
      .replace(/(\d+).(\d+).(\d+)/, "$2/$1/$3");
    let d = new Date(str_date);
    let str_format = format ? format : "DD.MM.YYYY";
    if (Type.isFunction(window.moment)) {
      return window.moment(d).format(str_format);
    }
    return d.toLocaleDateString("ru-RU");
  },
};
const namespace = (namespaceName, parent = false, endDefaultValue = "") => {
  var parts = namespaceName.split(".");
  var result = {};
  if (!parent) parent = result;
  for (let i = 0, l = parts.length; i < l; i++) {
    if (Type.isUndefined(parent[parts[i]])) {
      if (i === l - 1) {
        parent[parts[i]] = endDefaultValue;
      } else {
        parent[parts[i]] = {};
      }
    }
    parent = parent[parts[i]];
  }
  return result;
};
const VModel = {
  getMap(container, field, selector = "[v-model]", attrName = "v-model") {
    if (!container) return;
    let arr = container.querySelectorAll(selector);
    let result = {};
    arr.forEach(function (el) {
      let name = el.getAttribute(attrName);
      if (name.indexOf(".") !== -1) {
        namespace(name, result, "");
      } else {
        result[name] = {};
      }
    });
    if (field) return result[field];
    return result;
  },
  merge(mapModel, data) {
    let ob;
    if (mapModel && data) {
      ob = {};
      Object.keys(mapModel).forEach(function (key) {
        if (Type.isObjectLike(mapModel[key])) {
          ob[key] = VModel.merge(mapModel[key], data[key]);
        } else {
          if (Type.isUndefined(data[key])) {
            ob[key] = mapModel[key];
          } else {
            ob[key] = data[key];
          }
        }
      });
    }
    return ob;
  },
  /**
   *
   * @param {*} o object
   * @param {*} key
   * @param {*} defaultValue
   * @returns
   */
  getValue(o, key, defaultValue = "") {
    if (!o) return defaultValue;
    let k = "";
    let fu = BX.parseJSON($("<div>" + key + "</div>").text());
    if (Type.isFunction(fu)) {
      try {
        return fu(o);
      } catch (e) {
        console.error(e);
        console.log(fu.toString());
        return defaultValue;
      }
    }
    if (key.indexOf("else") > -1) {
      k = key.split("else");
      defaultValue = k[1].trim();
      key = k[0].trim();
    }
    k = key.split(".");
    if (Type.isPlainObject(o[k[0]]) && k.length > 1) {
      return this.getValue(o[k[0]], key.replace(k[0] + ".", ""), defaultValue);
    } else if (Type.isArray(o[k[0]]) && k.length > 1 && o[k[0]].length === 0) {
      return defaultValue;
    }
    return o[k[0]] ? o[k[0]] : defaultValue;
  },
  /**
   *
   * @param {*} stringTemplate
   * @param {*} data
   * @returns string
   */
  replaceTemplate(stringTemplate, data) {
    stringTemplate = stringTemplate.replace(/(\r\n|\n|\r|\t)/gm, "");
    return stringTemplate.replace(/{{(.*?)}}/g, (entry, key) =>
      convert.ToString(VModel.getValue(data, key))
    );
  },
};
const MAXZINDEX = 16_777_271;
const VSCore = {
  utilURL: utilURL,
  in_array: in_array,
  isJQueryNode: isJQueryNode,
  getTag: getTag,
  isNodeList: isNodeList,
  registerFunction: registerFunction,
  getFunction: getFunction,
  runFunction: runFunction,
  moveToElement: moveToElement,
  CONTROL: CONTROL,
  namespace: namespace,
  VModel: VModel,
  parseNumber(value) {
    value = parseFloat(value);
    if (isNaN(value)) {
      value = 0;
    }
    return value;
  },
  isEqual: (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  },
  convert: convert,
  isShown: (selector) => {
    /// возвращает true, если элемент находится в области просмотра частично или полностью.
    let t = document.querySelector(selector);
    if (!t) return;
    let wt = BX.scrollTop(window),
      wh = BX.height(window),
      eh = BX.height(t),
      et = t.offsetTop;
    if (wt + wh >= et && wt + wh - eh * 2 <= et + (wh - eh)) {
      return true;
    } else {
      return false;
    }
  },
  autoHeight: (elem) => {
    elem.style.height = "1px";
    elem.style.height = elem.scrollHeight + 2 + "px";
  },
  maxHeight: (container, selector = "*") => {
    if (!selector) return;
    if (typeof container === "string")
      container = document.querySelector(container);
    if (!Type.isElementNode(container)) container = document.body;
    let h = 0;
    container.querySelectorAll(selector).forEach(function (it) {
      let eh = VSCore.parseNumber(getComputedStyle(it).height);
      if (h < eh) h = eh;
    });
    return h;
  },
  zIndexMax(isElement) {
    let elements = document.querySelectorAll("*"),
      highest_index = 0,
      el;
    for (let i = 0, l = elements.length; i < l - 1; i++) {
      let z = this.parseNumber(getComputedStyle(elements[i]).zIndex);
      if (z > highest_index) {
        highest_index = z;
        el = elements[i];
      }
    }
    if (isElement) return el;
    return highest_index;
  },
  zIndexNext() {
    let z = this.zIndexMax();
    if (z >= MAXZINDEX) {
      z = MAXZINDEX;
    } else if (z < 4000) {
      z = 4000;
    } else {
      z += 10;
    }
    return z;
  },
  formatRUB: function (value) {
    //₽
    return "#&nbsp;&#8381;".replace(
      /(^|[^&])#/,
      "$1" + BX.util.number_format(value, 0, ".", "&nbsp;")
    );
  },
};
exports.VSCore = VSCore;
